export const filterInRange = (data, selectedRange)=>{
    let seriesData = [...data];
    if (selectedRange.start){
        seriesData = seriesData.filter(point => new Date(point[0]).getTime() >= selectedRange.start);
    }
    if (selectedRange.end){
        seriesData = seriesData.filter(point => new Date(point[0]).getTime() <= selectedRange.end);
    }
    return seriesData
}


// Function to convert data series for bar chart display, focusing on returns within the selected range
export const convertToBarData = (dataSeries, selectedRange) => {
    const keys = new Set();
    const customColors = {};
    const barData = dataSeries.map(plotConfig => {
        return plotConfig.data.map(seriesConfig => {
            // Assuming data is sorted by timestamp
            let seriesData = filterInRange(seriesConfig.data, selectedRange)
            if (seriesData.length < 2) return null; // Not enough data to calculate return
            const firstValue = seriesData[0][1]; // First value in the selected range
            const lastValue = seriesData[seriesData.length - 1][1]; // Last value in the selected range
            const returnValue = ((lastValue - firstValue) / firstValue) * 100; // Calculate return percentage
            keys.add(seriesConfig.name);
            customColors[seriesConfig.name] = seriesConfig.stroke;
            return {
                id: seriesConfig.name, // Use series name as 'x'
                [seriesConfig.name]: returnValue // Return calculated as 'value'
            };
        }).filter(item => item !== null); // Filter out any nulls from series with insufficient data
    }).flat().sort((a, b)=>a[Object.keys(a).filter(k=>k!=='id')[0]] - b[Object.keys(b).filter(k=>k!=='id')[0]]); // Flatten and sort by timestamp

    return {
        data: barData, keys: Array.from(keys), customColors
    }
};
